var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control",attrs:{"required":_vm.required},on:{"change":_vm.onChange}},[_c('option',{attrs:{"value":""}},[_vm._v("Selecciona")]),_vm._l((_vm.items),function(item,index){return _c('option',{key:index,domProps:{"value":item.id}},[_vm._v(_vm._s(item.name))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }